export const isClient = typeof window === "object";
